import { render, staticRenderFns } from "./basketball-data.vue?vue&type=template&id=4b399784&scoped=true&"
import script from "./basketball-data.vue?vue&type=script&lang=js&"
export * from "./basketball-data.vue?vue&type=script&lang=js&"
import style0 from "./basketball-data.vue?vue&type=style&index=0&id=4b399784&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b399784",
  null
  
)

export default component.exports